var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"mt-5 mb-5 p-4 text-center"},[_vm._v("«Дао, которое может быть выражено словами не есть постоянное дао...»")])}
var staticRenderFns = []

export { render, staticRenderFns }